import CartoonIcon from 'imgs/visual-styles/CartoonIcon.svg';
import ConceptualIcon from 'imgs/visual-styles/ConceptualIcon.svg';
import MinimalIcon from 'imgs/visual-styles/MinimalIcon.svg';
import RealisticIcon from 'imgs/visual-styles/RealisticIcon.svg';
import SimpleIcon from 'imgs/visual-styles/SimpleIcon.svg';
import StreamlineIcon from 'imgs/visual-styles/StreamlineIcon.svg';
import StylizedIcon from 'imgs/visual-styles/StylizedIcon.svg';
import AllStylesIcon from 'imgs/visual-styles/AllStylesIcon.svg';

const STYLE_ICONS: Record<string, string> = {
  comic: CartoonIcon,
  conceptual: ConceptualIcon,
  illustrated: RealisticIcon,
  lineart: SimpleIcon,
  flat: MinimalIcon,
  expressive: StylizedIcon,
  streamline: StreamlineIcon,
  all: AllStylesIcon
};

export default STYLE_ICONS;
